export default {
  index: { method: 'get', url: '/nft/index' }, // NFT概览
  buy: { method: 'post', url: '/nft/buy' }, // NFT认购签名
  buyPage: { method: 'get', url: '/nft/buy/page' }, // 我的NFT购买记录
  rewardPage: { method: 'get', url: '/nft/reward/page' } // 我的NFT奖励记录
}
